import { __decorate } from "tslib";
import { customElement } from "@microsoft/fast-element";
import { TreeItemTemplate as template, TreeItem } from "@microsoft/fast-foundation";
import { TreeItemStyles as styles } from "./tree-item.styles";
/**
 * The FAST tree item Custom Element. Implements, {@link @microsoft/fast-foundation#TreeItem}
 * {@link @microsoft/fast-foundation#TreeItemTemplate}
 *
 *
 * @public
 * @remarks
 * HTML Element: \<fast-tree-item\>
 *
 */
let FASTTreeItem = class FASTTreeItem extends TreeItem {
};
FASTTreeItem = __decorate([
    customElement({
        name: "fast-tree-item",
        template,
        styles,
    })
], FASTTreeItem);
export { FASTTreeItem };
/**
 * Styles for TreeItem
 * @public
 */
export const TreeItemStyles = styles;
